
import React from 'react';

import {Card,Box,CardHeader} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import {useSingleProfileStyle} from 'src/views/harvesting/fruit-profile/fruit-profile-single';

const LoadingComponent = ()=>{
  const classes = useSingleProfileStyle();
  return (
    <Box pb={1}>
      <Card
        className={classes.card}
  
        // onClick={()=>!!editProfile?setEditProfile(x):null}
      >
        <CardHeader
          className={classes.fishcard}
          avatar={
            <Skeleton variant="circle" width={68} height={68} />

          }
            
          title={ <Skeleton variant="text" width="150px" height={15} />}
          subheader={
            <React.Fragment>
              <Skeleton variant="text" width="200px" height={10} style={{marginTop:2}}/>
              {/* <Skeleton variant="text" width="180px"  height={8} /> */}

               
            </React.Fragment>
          }
        />
      </Card>
    </Box>
  ); 
};
const LoadingProfile = () =>{
  return(
    <>
      <LoadingComponent/>
      <LoadingComponent/>
      <LoadingComponent/>
    </>
  );
};

export default LoadingProfile;